import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './Components/HomePage';
import Header from './Layouts/Header';
import Footer from './Layouts/Footer';
// Legacy stylesheets from the previous industry and service pages. Those pages now use Industry.css and
// Service.css, but other pages (company, contact, home) still inherit a few shared class rules from these
// files, so they stay loaded in their original order. Remove once those pages have their own styles.
import './CSS/EdTech.css';
import './CSS/Finance&Accounting.css';
import './CSS/Healthcare.css';
import './CSS/Logistics.css';
import './CSS/Retail.css';
import './CSS/Pharmaceutical.css';
import './CSS/HumanResource.css';
import './CSS/AI&ML.css';
import './CSS/DataEngineering.css';
import './CSS/GenerativeAI.css';
import './CSS/SoftwareEngineering.css';
import ContactUs from './Components/ContactUs';
import PrivacyPolicy from './Components/PrivacyPolicy';
import Company from './Components/Company';
import Products from './Components/Products';
import NotFound from './Components/NotFound';
import IndustryPage from './Components/IndustryPage';
import ServicePage from './Components/ServicePage';
import { SERVICES } from './Data/services';
import { INDUSTRIES } from './Data/industries';
import SeoManager from './Components/SeoManager';
import ScrollToTop from './Components/ScrollToTop';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <ScrollToTop />
        <SeoManager />
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/edtech" element={<IndustryPage key="edtech" slug="edtech" data={INDUSTRIES['edtech']} />} />
          <Route path="/finance-accounting" element={<IndustryPage key="finance-accounting" slug="finance-accounting" data={INDUSTRIES['finance-accounting']} />} />
          <Route path="/healthcare" element={<IndustryPage key="healthcare" slug="healthcare" data={INDUSTRIES['healthcare']} />} />
          <Route path="/pharmaceutical" element={<IndustryPage key="pharmaceutical" slug="pharmaceutical" data={INDUSTRIES['pharmaceutical']} />} />
          <Route path="/aiml" element={<ServicePage key="aiml" data={SERVICES['aiml']} />} />
          <Route path="/dataengineering" element={<ServicePage key="dataengineering" data={SERVICES['dataengineering']} />} />
          <Route path="/generativeai" element={<ServicePage key="generativeai" data={SERVICES['generativeai']} />} />
          <Route path="/softwareengineering" element={<ServicePage key="softwareengineering" data={SERVICES['softwareengineering']} />} />
          <Route path="/products" element={<Products />} />
          <Route path="/company" element={<Company />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
